/* tslint:disable */
/* eslint-disable */
/**
 * Payment Service API
 * 통합 정리된 결제 서비스 API 명세 - 완전 React 마이그레이션  **주요 개선사항:** - 모든 Thymeleaf 페이지를 REST API로 변환 - 기능별 그룹화된 경로 구조 - 표준화된 응답 형식 - React SPA 완전 지원  **API 구조:** - 결제수단 관리: `/api/v1/payment-methods/_*` - 구독 관리: `/api/v1/subscriptions/_*`  - 플랜 관리: `/api/v1/plans/_*` - 주문 관리: `/api/v1/orders/_*` - 대시보드: `/api/v1/dashboard/_*` - NicePay 결제: `/api/v1/payment/nicepay/_*` - 세션 관리: `/api/v1/auth/_*` 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface OrderResponse
 */
export interface OrderResponse {
    /**
     * 주문 ID
     * @type {string}
     * @memberof OrderResponse
     */
    'id': string;
    /**
     * 사용자 ID
     * @type {string}
     * @memberof OrderResponse
     */
    'userId'?: string;
    /**
     * 주문 금액
     * @type {string}
     * @memberof OrderResponse
     */
    'amount': string;
    /**
     * 주문 상태
     * @type {string}
     * @memberof OrderResponse
     */
    'status': OrderResponseStatusEnum;
    /**
     * 주문 타입
     * @type {string}
     * @memberof OrderResponse
     */
    'orderType'?: OrderResponseOrderTypeEnum;
    /**
     * 상품명
     * @type {string}
     * @memberof OrderResponse
     */
    'productName'?: string;
    /**
     * 상품 코드
     * @type {string}
     * @memberof OrderResponse
     */
    'productCode'?: string;
    /**
     * 플랜 코드
     * @type {string}
     * @memberof OrderResponse
     */
    'productPlanCode'?: string;
    /**
     * 결제 방법
     * @type {string}
     * @memberof OrderResponse
     */
    'paymentMethod'?: string;
    /**
     * 결제일시
     * @type {string}
     * @memberof OrderResponse
     */
    'paymentDate'?: string;
    /**
     * 구매자 이름
     * @type {string}
     * @memberof OrderResponse
     */
    'buyerName'?: string;
    /**
     * 구매자 이메일
     * @type {string}
     * @memberof OrderResponse
     */
    'buyerEmail'?: string;
    /**
     * 거래 ID
     * @type {string}
     * @memberof OrderResponse
     */
    'tid'?: string;
    /**
     * 빌링키
     * @type {string}
     * @memberof OrderResponse
     */
    'billingKey'?: string;
    /**
     * 상품 타입
     * @type {string}
     * @memberof OrderResponse
     */
    'itemType'?: OrderResponseItemTypeEnum;
    /**
     * 생성일시
     * @type {string}
     * @memberof OrderResponse
     */
    'createdAt': string;
    /**
     * 수정일시
     * @type {string}
     * @memberof OrderResponse
     */
    'updatedAt'?: string;
}

export const OrderResponseStatusEnum = {
    Pending: 'PENDING',
    Processing: 'PROCESSING',
    Completed: 'COMPLETED',
    Paid: 'PAID',
    Cancelled: 'CANCELLED',
    Failed: 'FAILED',
    Refunded: 'REFUNDED'
} as const;

export type OrderResponseStatusEnum = typeof OrderResponseStatusEnum[keyof typeof OrderResponseStatusEnum];
export const OrderResponseOrderTypeEnum = {
    Subscription: 'SUBSCRIPTION',
    OneTime: 'ONE_TIME'
} as const;

export type OrderResponseOrderTypeEnum = typeof OrderResponseOrderTypeEnum[keyof typeof OrderResponseOrderTypeEnum];
export const OrderResponseItemTypeEnum = {
    Course: 'COURSE',
    Ebook: 'EBOOK',
    Service: 'SERVICE',
    Subscription: 'SUBSCRIPTION',
    DigitalGoods: 'DIGITAL_GOODS',
    Other: 'OTHER'
} as const;

export type OrderResponseItemTypeEnum = typeof OrderResponseItemTypeEnum[keyof typeof OrderResponseItemTypeEnum];


